import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'
import { IconCodeEmum, Iconfont } from '@src/components'
import securitySelected from '@assets/icon/security-selected.png'
import security from '@assets/icon/security.png'
import { Modal } from 'antd-mobile'
import { QueryDiscountListByType } from '@src/api'
import { isChinese } from '@src/utils'

// 弹框-权益券列表、优惠券列表、优惠活动列表
class GLModalCoupons extends BaseComponent {
	static propTypes = {
		isShow: PropTypes.bool,
		type: PropTypes.number, // 1权益券 2优惠券 30优惠活动
		params: PropTypes.object,
		close: PropTypes.func,
		select: PropTypes.func,
		loading: PropTypes.func,
	}

	static defaultProps = {
		isShow: false,
		type: 1,
		params: {
			discountId: 0, // 选中优惠id
			discountType: 1, // 优惠类型
			productList: [], // 下单产品列表
			discountList: [], // 用户已选优惠列表
		},
		close: () => {},
		select: (item) => {},
		loading: (isLoading) => {},
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 生命周期 */
	constructor(props) {
		super(props)
		this.state = {
			resultData: {},
			buttonIndex: 1,
			currentCoupon: {},
		}
	}

	cnReg = () => new RegExp('[\\u4E00-\\u9FFF]+', 'g')

	// discountType=0,就会选中默认的
	// let api = new QueryDiscountByBooking()
	// 因此,为了不让选中默认的,即使不选择优惠,也要返回discountType

	componentDidUpdate(prevProps, prevState, snapshot) {
		console.log('componentDidUpdate', prevProps)
		console.log('componentDidUpdate', prevState)
		if (prevProps.isShow !== this.props.isShow && this.props.isShow === true) {
			const self = this
			this.setState(
				{
					buttonIndex: 1,
					currentCoupon: {},
				},
				function() {
					self.queryDiscountListByType()
				},
			)
		}
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 方法 */
	queryDiscountListByType() {
		const self = this
		self.props.loading(true)

		let params = this.props.params || {}

		let api = new QueryDiscountListByType()
		api.setParams(params)
		api.execute()
			.then(function(result) {
				self.props.loading(false)
				console.log(JSON.stringify(result))
				if (result.resultCode === '0') {
					let resultData = result.resultData || {}
					let ableDiscountList = resultData.ableDiscountList || []
					let selectItem = {
						discountId: 0,
						discountType: params.discountType || 0,
					}
					ableDiscountList.map((item) => {
						// item.displayDiscountValue = '全额减免'
						if (item.isSelected) {
							selectItem = item
						}
					})
					self.setState({
						resultData,
						currentCoupon: selectItem || {},
					})
				}
			})
			.catch(function(error) {
				self.props.loading(false)
				console.error(error)
			})
	}

	selectCouponModalButton(index) {
		this.setState({
			buttonIndex: index,
		})
	}

	selectCoupon(item) {
		let params = this.props.params || {}
		let currentCoupon = this.state.currentCoupon || {}
		if (currentCoupon.discountId === item.discountId) {
			this.setState({
				currentCoupon: {
					discountId: 0,
					discountType: params.discountType || 0,
				},
			})
		} else {
			this.setState({
				currentCoupon: item,
			})
		}
	}

	couponCommit() {
		this.props.select(this.state.currentCoupon)
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ render */
	renderList() {
		let buttonIndex = this.state.buttonIndex || 1
		let currentCoupon = this.state.currentCoupon || {}
		let resultData = this.state.resultData
		let ableDiscountList = resultData.ableDiscountList || []
		let disableDiscountList = resultData.disableDiscountList || []
		let array = ableDiscountList
		if (this.state.buttonIndex === 2) {
			array = disableDiscountList
		}

		let component = null
		if (+this.props.type === 1) {
			component = array.map((item, index) => {
				return (
					<div className={CSS.couponsCell} key={index}>
						<div className={CSS.couponsCellLeft}>
							<img src={item.discountIcon} />
						</div>
						<div
							className={CSS.couponsCellRight}
							onClick={() => {
								if (buttonIndex === 1) {
									this.selectCoupon(item)
								}
							}}
						>
							<div className={CSS.couponsCellRightInner1}>
								<p className={buttonIndex === 2 ? CSS.disableText : ''}>
									{item.discountName}
								</p>
								<p className={buttonIndex === 2 ? CSS.disableText : ''}>
									{item.discountDesc}
								</p>
							</div>
							{buttonIndex === 1 ? (
								<div className={CSS.couponsCellRightInner2}>
									{currentCoupon.discountId === item.discountId ? (
										<img src={securitySelected} alt='' />
									) : (
										<img src={security} alt='' />
									)}
								</div>
							) : null}
						</div>
					</div>
				)
			})
		} else if (+this.props.type === 2) {
			component = array.map((item, index) => {
				return (
					<div className={CSS.couponsCell} key={index}>
						<div className={CSS.couponsCellLeft}>
							<div className={CSS.couponsCellLeftInner1}>
								<p
									className={`${buttonIndex === 2 ? CSS.disableText : ''} ${
										this.cnReg().test(item.displayDiscountValue)
											? CSS.couponsCellLeftInner1Cn
											: ''
									} ${
										isChinese(item.displayDiscountValue) ? CSS.chinesFont : null
									}`}
								>
									{item.displayDiscountValue}
								</p>
								<p className={buttonIndex === 2 ? CSS.disableText : ''}>
									{item.displayUnitName}
								</p>
							</div>
							{_.isHasValue(item.displayCouponTitle) ? (
								<p
									className={CSS.couponsCellLeftInner2}
									style={buttonIndex === 2 ? { color: '#CCCCCC' } : {}}
								>
									{item.displayCouponTitle}
								</p>
							) : null}
						</div>
						<div
							className={CSS.couponsCellRight}
							onClick={() => {
								if (buttonIndex === 1) {
									this.selectCoupon(item)
								}
							}}
						>
							<div className={CSS.couponsCellRightInner1}>
								<p className={buttonIndex === 2 ? CSS.disableText : ''}>
									{item.discountName}
								</p>
								<p className={buttonIndex === 2 ? CSS.disableText : ''}>
									{item.discountDesc}
								</p>
							</div>
							{buttonIndex === 1 ? (
								<div className={CSS.couponsCellRightInner2}>
									{currentCoupon.discountId === item.discountId ? (
										<img src={securitySelected} alt='' />
									) : (
										<img src={security} alt='' />
									)}
								</div>
							) : null}
						</div>
					</div>
				)
			})
		} else if (+this.props.type === 30) {
			component = array.map((item, index) => {
				return (
					<div className={CSS.activityCell} key={index}>
						<div className={CSS.activityCellLeft}>
							{item.discountName}
							<span className={CSS.redText}>{item.displayDiscountPrice}</span>
						</div>
						<div
							className={CSS.activityCellRight}
							onClick={this.selectCoupon.bind(this, item)}
						>
							{currentCoupon.discountId === item.discountId ? (
								<img src={securitySelected} alt='' />
							) : (
								<img src={security} alt='' />
							)}
						</div>
					</div>
				)
			})
		}
		if (array.length === 0) {
			component = (
				<div className={CSS.empty}>
					<img
						src='https://publicdev.oss-cn-beijing.aliyuncs.com/icon/empty-placeholder-3.png'
						alt=''
					/>
					<p>{resultData.noneDiscountTip || '暂无优惠'}</p>
				</div>
			)
		}
		return component
	}

	render() {
		let { isShow, type, close } = this.props
		let resultData = this.state.resultData
		let ableDiscountList = resultData.ableDiscountList || []

		let isCanCommit = false
		// 显示的是可用列表 + 可用列表不为空 = 显示提交按钮
		if (ableDiscountList.length > 0 && this.state.buttonIndex === 1) {
			isCanCommit = true
		}

		return (
			<Modal
				popup
				visible={isShow}
				className={CSS.modal}
				animationType='slide-up'
				onClose={close.bind(this)}
			>
				<Iconfont
					font={IconCodeEmum.CLOSE}
					style={{
						fontSize: '.32rem',
						color: '#D8D8D8',
						position: 'absolute',
						top: 0,
						right: '.4rem',
					}}
					onPress={close.bind(this)}
				/>
				<p className={CSS.modalTitle}>{resultData.discountTitle || '优惠'}</p>
				{_.isHasValue(resultData.discountTitleTip) ? (
					<p className={CSS.modalTip}>{resultData.discountTitleTip}</p>
				) : null}
				{type === 1 || type === 2 ? (
					<div className={CSS.modalButtonBar}>
						<div
							className={CSS.modalButtonBarItem}
							onClick={this.selectCouponModalButton.bind(this, 1)}
						>
							<p
								style={
									this.state.buttonIndex === 1
										? {
												fontWeight: 'bold',
												color: '#222222',
										  }
										: {}
								}
							>
								{resultData.ableQtyTitle}
							</p>
							<p
								style={
									this.state.buttonIndex === 1
										? {
												background:
													'linear-gradient(90deg, #FFDB55 0%, #FFC300 100%)',
										  }
										: {}
								}
							></p>
						</div>
						<div
							className={CSS.modalButtonBarItem}
							onClick={this.selectCouponModalButton.bind(this, 2)}
						>
							<p
								style={
									this.state.buttonIndex === 2
										? {
												fontWeight: 'bold',
												color: '#222222',
										  }
										: {}
								}
							>
								{resultData.disabledQtyTitle}
							</p>
							<p
								style={
									this.state.buttonIndex === 2
										? {
												background:
													'linear-gradient(90deg, #FFDB55 0%, #FFC300 100%)',
										  }
										: {}
								}
							></p>
						</div>
					</div>
				) : null}
				<div className={CSS.content}>
					<div
						className={CSS.couponsList}
						style={{
							paddingBottom: isCanCommit ? 0 : '.4rem',
						}}
					>
						{this.renderList()}
					</div>
					{isCanCommit ? (
						<div className={CSS.modalCommitBg}>
							<p className={CSS.modalCommit} onClick={this.couponCommit.bind(this)}>
								确定
							</p>
						</div>
					) : null}
				</div>
			</Modal>
		)
	}
}

export default GLModalCoupons
